import React, { Component } from 'react';
import { Input } from 'react-bootstrap';
import 'react-select/dist/react-select.css';

export default class HiddenInputField extends Component {
  render() {
    const { input } = this.props;
    return (
      <Input
        {...input}
        className="hidden"
        standalone
        type="text"
        value={input.V}
        onChange={input.onChange(this.props.V)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/hiddenInputField.jsx